import { Trash2, Download } from "lucide-react";
import { downloadAuthed } from "./helpers";

export function UsersTable({
  users,
  selected,
  toggleSelect,
  toggleAll,
  onDelete,
  onRoleChange,
  onBulkDelete,
}) {
  return (
    <section>
      <div className="flex items-center justify-between mb-3 gap-3 flex-wrap">
        <h2 className="text-lg font-bold text-slate-200">Active team ({users.length})</h2>
        <div className="flex items-center gap-2">
          {selected.size > 0 && (
            <button
              onClick={onBulkDelete}
              data-testid="admin-bulk-delete"
              className="text-xs px-3 py-1.5 rounded-lg bg-[#ff3b5c] text-white font-bold inline-flex items-center gap-1.5 hover:opacity-90 transition-opacity"
            >
              <Trash2 size={12} /> Delete {selected.size} selected
            </button>
          )}
          <button
            onClick={() => downloadAuthed("/export/users.csv", "team.csv")}
            data-testid="export-users"
            className="text-xs px-3 py-1.5 rounded-lg border border-slate-700 hover:border-[color:var(--accent)] hover:text-[color:var(--accent)] inline-flex items-center gap-1.5 text-slate-300 transition-colors"
          >
            <Download size={12} /> Export CSV
          </button>
        </div>
      </div>
      <div className="card-surface admin-card overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="bg-[#0b0d12] border-b border-[#2a3447] text-slate-400 uppercase text-xs tracking-widest">
            <tr>
              <th className="px-4 py-3 w-10">
                <input
                  type="checkbox"
                  checked={users.length > 0 && selected.size === users.length}
                  ref={(el) => { if (el) el.indeterminate = selected.size > 0 && selected.size < users.length; }}
                  onChange={toggleAll}
                  data-testid="admin-check-all"
                  aria-label="Select all"
                  className="accent-[color:var(--accent)] cursor-pointer"
                />
              </th>
              <th className="text-left px-6 py-3">Name</th>
              <th className="text-left px-6 py-3">Email</th>
              <th className="text-left px-6 py-3">Department</th>
              <th className="text-left px-6 py-3">Location</th>
              <th className="text-left px-6 py-3">Role</th>
              <th className="px-6 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr
                key={u.id}
                className={`border-b border-[#1a202c] hover:bg-[#121620] transition-colors ${selected.has(u.id) ? "bg-[color:var(--accent)]/5" : ""}`}
                data-testid={`admin-row-${u.id}`}
              >
                <td className="px-4 py-3">
                  <input
                    type="checkbox"
                    checked={selected.has(u.id)}
                    onChange={() => toggleSelect(u.id)}
                    data-testid={`admin-check-${u.id}`}
                    aria-label={`Select ${u.name}`}
                    className="accent-[color:var(--accent)] cursor-pointer"
                  />
                </td>
                <td className="px-6 py-3 font-semibold">{u.name}</td>
                <td className="px-6 py-3 text-slate-400">{u.email}</td>
                <td className="px-6 py-3 text-slate-300">{u.department || "—"}</td>
                <td className="px-6 py-3 text-slate-300">{u.location || "—"}</td>
                <td className="px-6 py-3">
                  <select
                    value={u.role}
                    onChange={(e) => onRoleChange(u.id, e.target.value)}
                    data-testid={`admin-role-${u.id}`}
                    className="bg-[#0b0d12] border border-[#2a3447] rounded px-2 py-1 text-xs"
                  >
                    <option value="admin">admin</option>
                    <option value="manager">manager</option>
                    <option value="employee">employee</option>
                  </select>
                </td>
                <td className="px-6 py-3 text-right">
                  <button
                    onClick={() => onDelete(u.id)}
                    data-testid={`admin-delete-${u.id}`}
                    className="text-slate-500 hover:text-[#ff3b5c] transition-colors"
                  >
                    <Trash2 size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default UsersTable;
